import React from "react";
import ReactDOM from "react-dom";
import TodoList from "./components/App.js";
import eventBus from "../../../../../util/eventBus";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model);
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model;
        },
        init: function (props) {
            console.log("-----init", this.model.style, props);
            setHtml(this.model, props);
        },
        update: function (props) {
            console.log("-----update", this.model, props);
            eventBus.pub(this.model, "update", props);
        },
        destoryed: function () {
            console.log("-----destoryed", this.model);
            ReactDOM.unmountComponentAtNode(this.model.dom);
        },
    };

    var setHtml = function (model, primaryProps) {
        KDApi.loadFile(["./css/index.css", "./js/myTool.js"], model, () => {
            class Root extends React.Component {
                constructor(props) {
                    super(props);
                    this.state = {
                        customProps: props.customProps,
                        model: props.model,
                    };
                }

                componentDidMount() {
                    const { model } = this.state;
                    this.updateSub = eventBus.sub(model, "update", (updateProps) => {

                        this.setState({ customProps: updateProps }, () => {
                            if (updateProps?.data) {
                                const { data, eventName } = updateProps?.data;
                                this.childRef.updateField(data, eventName);
                            }
                        });
                    });
                }

                componentWillUnmount() {
                    eventBus.unsub(this.updateSub);
                }

                childRef = {};

                onRef = (ref) => {
                    this.childRef = ref;
                };

                I18N = key => KDApi.getLangMsg(model, key)

                render() {
                    let myTool = new KdWtcMyTool();
                    const { customProps, model } = this.state;
                    return (
                        <TodoList I18N={this.I18N} myTool={myTool} model={model} customProps={customProps} onRef={this.onRef} />
                    );
                }
            }

            ReactDOM.render(
                <Root model={model} customProps={primaryProps} />,
                model.dom
            );
        });
    };

    // 注册自定义组件
    KDApi.register("positionhisquery", MyComponent, {
        isMulLang: true,
    });
})(window.KDApi);
